'use client';

import { Routes, Route, Navigate } from "react-router-dom";
import AccountPage from "./pages/AccountPage";
import AchPage from "./pages/AchPage";
import AtmEventPage from "./pages/AtmEventPage";
import Dashboard from "./pages/Dashboard";
import GoaEventPage from "./pages/GoaEventPage";
import LocationsPage from "./pages/LocationsPage";
import TrkEventPage from "./pages/TrkEventPage";
import UsersPage from "./pages/UsersPage";
import LocationPage from "./pages/LocationPage";
import UserPage from "./pages/UserPage";
import GoaPage from "./pages/GoaPage";
import TrkPage from "./pages/TrkPage";
import AtmPage from "./pages/AtmPage";
import CtmPage from "./pages/CtmPage";
import CtmEventPage from "./pages/CtmEventPage";
import LocationServiceSearchPage from "./pages/LocationServiceSearchPage";
import LocationServicePage from "./pages/LocationServicePage";
import GoasPage from "./pages/GoasPage";
import LocationServiceStartPage from "./pages/LocationServiceStartPage";
import TrkAssetPage from '@/components/pages/TrkAssetPage';
import AtmAssetPage from '@/components/pages/AtmAssetPage';
import LocationReportPage from '@/components/pages/LocationReportPage';
import LocationServiceViewPage from "./pages/LocationServiceViewPage";
import LocationReportTablePage from "./pages/LocationReportTablePage";
import SettingsPage from "./pages/SettingsPage";
import AssetsPage from "./pages/AssetsPage";
import EventsPage from "./pages/EventsPage";
import Home from "../app/page";
import BusinessUnitsPage from "./pages/BusinessUnitsPage";
import BusinessUnitDashboardPage from "./pages/BusinessUnitDashboardPage";
import TomsVendingMachinesPage from "./pages/TomsVendingMachinesPage";
import TomsVendingLocationsPage from "./pages/TomsVendingLocationsPage";
import TomsVendingLocationDetailPage from "./pages/TomsVendingLocationDetailPage";
import TomsVendingLocationInventoryAdjustmentPage from "./pages/TomsVendingLocationInventoryAdjustmentPage";
import TomsVendingLocationSiteVisitPage from "./pages/TomsVendingLocationSiteVisitPage";
import TomsVendingMachineDetailPage from "./pages/TomsVendingMachineDetailPage";
import TomsVendingMachineInventoryPage from "./pages/TomsVendingMachineInventoryPage";
import TomsVendingInventoryPage from "./pages/TomsVendingInventoryPage";
import TomsVendingCatalogQuickEditPage from "./pages/TomsVendingCatalogQuickEditPage";
import TomsVendingBrandsPage from "./pages/TomsVendingBrandsPage";
import TomsVendingCategoriesPage from "./pages/TomsVendingCategoriesPage";
import TomsVendingInventoryMovementsPage from "./pages/TomsVendingInventoryMovementsPage";
import TomsVendingInventoryRejectSummaryPage from "./pages/TomsVendingInventoryRejectSummaryPage";
import { RequireSouthernMint } from "./core/RequireSouthernMint";
import { RequireTomsVending } from "./core/RequireTomsVending";
import { RequireTomsVendingOperational } from "./core/RequireTomsVendingOperational";
import { RequireInventoryAuditor } from "./core/RequireInventoryAuditor";
import { RequireAdmin } from "./core/RequireAdmin";
import BusinessUnitSetupPage from "./pages/BusinessUnitSetupPage";
import InventoryAuditorLocationsPage from "./pages/InventoryAuditorLocationsPage";
import InventoryAuditorLocationDetailPage from "./pages/InventoryAuditorLocationDetailPage";
import InventoryAuditorLocationSiteVisitPage from "./pages/InventoryAuditorLocationSiteVisitPage";
import InventoryAuditorItemCatalogPage from "./pages/InventoryAuditorItemCatalogPage";
import InventoryAuditorItemDetailPage from "./pages/InventoryAuditorItemDetailPage";
import TomsVendingVendorsPage from "./pages/TomsVendingVendorsPage";
import TomsVendingPurchaseOrdersPage from "./pages/TomsVendingPurchaseOrdersPage";
import TomsVendingPurchaseOrderDetailPage from "./pages/TomsVendingPurchaseOrderDetailPage";
import TomsVendingPoFromPhotoPage from "./pages/TomsVendingPoFromPhotoPage";
import TomsVendingReportsPage from "./pages/TomsVendingReportsPage";
import TomsVendingSiteVisitReportPage from "./pages/TomsVendingSiteVisitReportPage";
import TomsVendingRejectReportPage from "./pages/TomsVendingRejectReportPage";
import TomsVendingAllSiteVisitsPage from "./pages/TomsVendingAllSiteVisitsPage";
import TomsVendingSiteVisitDetailPage from "./pages/TomsVendingSiteVisitDetailPage";
import TomsVendingInferredSalesReportPage from "./pages/TomsVendingInferredSalesReportPage";
import TomsVendingReconciliationReportPage from "./pages/TomsVendingReconciliationReportPage";
import TomsVendingDailySummaryReportPage from "./pages/TomsVendingDailySummaryReportPage";
import InventoryAuditorVendorsPage from "./pages/InventoryAuditorVendorsPage";
import InventoryAuditorPurchaseOrdersPage from "./pages/InventoryAuditorPurchaseOrdersPage";
import InventoryAuditorPurchaseOrderDetailPage from "./pages/InventoryAuditorPurchaseOrderDetailPage";
import InventoryAuditorReportsPage from "./pages/InventoryAuditorReportsPage";
import InventoryAuditorStoreCountsReportPage from "./pages/InventoryAuditorStoreCountsReportPage";

function AppRoutes() {
    return (
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/app" element={<Dashboard />} />
                <Route path="/app/dashboard" element={<Dashboard />} />
                <Route path="/app/account" element={<AccountPage />} />
                <Route path="/app/settings" element={<SettingsPage />} />
                <Route path="/app/business-units" element={<BusinessUnitsPage />} />
                <Route path="/app/business-units/setup" element={<Navigate to="/app/business-units" replace />} />
                <Route path="/app/business-units/:code/dashboard" element={<BusinessUnitDashboardPage />} />
                <Route element={<RequireAdmin />}>
                    <Route path="/app/business-units/:code/setup" element={<BusinessUnitSetupPage />} />
                </Route>
                <Route path="/app/users" element={<UsersPage />} />
                <Route path="/app/users/:userId" element={<UserPage />} />

                <Route element={<RequireTomsVending />}>
                    <Route path="/app/toms-vending/reports/site-visits" element={<TomsVendingSiteVisitReportPage />} />
                    <Route path="/app/toms-vending/reports/rejects" element={<TomsVendingRejectReportPage />} />
                    <Route path="/app/toms-vending/reports/inferred-sales" element={<TomsVendingInferredSalesReportPage />} />
                    <Route path="/app/toms-vending/reports/reconciliation" element={<TomsVendingReconciliationReportPage />} />
                    <Route path="/app/toms-vending/reports/daily-summary" element={<TomsVendingDailySummaryReportPage />} />
                    <Route path="/app/toms-vending/reports" element={<TomsVendingReportsPage />} />
                    <Route path="/app/toms-vending/site-visits/:siteVisitId" element={<TomsVendingSiteVisitDetailPage />} />

                    <Route element={<RequireTomsVendingOperational />}>
                    <Route path="/app/toms-vending/vending-machines" element={<TomsVendingMachinesPage />} />
                    <Route element={<RequireAdmin />}>
                        <Route path="/app/toms-vending/inventory" element={<TomsVendingInventoryPage />} />
                        <Route path="/app/toms-vending/inventory/quick-edit" element={<TomsVendingCatalogQuickEditPage />} />
                        <Route path="/app/toms-vending/inventory/brands" element={<TomsVendingBrandsPage />} />
                        <Route path="/app/toms-vending/inventory/categories" element={<TomsVendingCategoriesPage />} />
                        <Route path="/app/toms-vending/inventory/reject-summary" element={<TomsVendingInventoryRejectSummaryPage />} />
                    </Route>
                    <Route path="/app/toms-vending/inventory/movements" element={<TomsVendingInventoryMovementsPage />} />
                    <Route path="/app/toms-vending/inventory/location-adjustment" element={<TomsVendingLocationInventoryAdjustmentPage />} />
                    <Route path="/app/toms-vending/locations" element={<TomsVendingLocationsPage />} />
                    <Route path="/app/toms-vending/locations/:locationId/site-visit" element={<TomsVendingLocationSiteVisitPage />} />
                    <Route path="/app/toms-vending/locations/:locationId" element={<TomsVendingLocationDetailPage />} />
                    <Route path="/app/toms-vending/locations/:locationId/machines/:machineId/inventory" element={<TomsVendingMachineInventoryPage />} />
                    <Route path="/app/toms-vending/locations/:locationId/machines/:machineId" element={<TomsVendingMachineDetailPage />} />
                    <Route path="/app/toms-vending/purchasing/vendors" element={<TomsVendingVendorsPage />} />
                    <Route path="/app/toms-vending/purchasing/purchase-orders" element={<TomsVendingPurchaseOrdersPage />} />
                    <Route path="/app/toms-vending/purchasing/purchase-orders/from-photo" element={<TomsVendingPoFromPhotoPage />} />
                    <Route path="/app/toms-vending/purchasing/purchase-orders/:poId" element={<TomsVendingPurchaseOrderDetailPage />} />
                    <Route path="/app/toms-vending/site-visits/recent" element={<TomsVendingAllSiteVisitsPage />} />
                    </Route>
                </Route>

                <Route element={<RequireInventoryAuditor />}>
                    <Route path="/app/inventory-auditor/catalog/:itemId" element={<InventoryAuditorItemDetailPage />} />
                    <Route path="/app/inventory-auditor/catalog" element={<InventoryAuditorItemCatalogPage />} />
                    <Route path="/app/inventory-auditor/locations" element={<InventoryAuditorLocationsPage />} />
                    <Route path="/app/inventory-auditor/site-visit" element={<InventoryAuditorLocationSiteVisitPage />} />
                    <Route path="/app/inventory-auditor/locations/:locationId/site-visit" element={<InventoryAuditorLocationSiteVisitPage />} />
                    <Route path="/app/inventory-auditor/locations/:locationId" element={<InventoryAuditorLocationDetailPage />} />
                    <Route path="/app/inventory-auditor/purchasing/vendors" element={<InventoryAuditorVendorsPage />} />
                    <Route path="/app/inventory-auditor/purchasing/purchase-orders" element={<InventoryAuditorPurchaseOrdersPage />} />
                    <Route path="/app/inventory-auditor/purchasing/purchase-orders/:poId" element={<InventoryAuditorPurchaseOrderDetailPage />} />
                    <Route path="/app/inventory-auditor/reports" element={<InventoryAuditorReportsPage />} />
                    <Route path="/app/inventory-auditor/reports/store-counts" element={<InventoryAuditorStoreCountsReportPage />} />
                </Route>

                <Route element={<RequireSouthernMint />}>
                    <Route path="/app/ach" element={<AchPage />} />
                    <Route path="/app/assets" element={<AssetsPage />} />
                    <Route path="/app/events" element={<EventsPage />} />
                    <Route path="/app/trk/events" element={<TrkEventPage />} />
                    <Route path="/app/trk/assets" element={<TrkPage />} />
                    <Route path="/app/trk/:trkId" element={<TrkAssetPage />} />
                    <Route path="/app/atm/:atmId" element={<AtmAssetPage />} />
                    <Route path="/app/atm/events" element={<AtmEventPage />} />
                    <Route path="/app/atm/assets" element={<AtmPage />} />
                    <Route path="/app/goa/events" element={<GoaEventPage />} />
                    <Route path="/app/goas" element={<GoasPage />} />
                    <Route path="/app/goas/:goaId" element={<GoaPage />} />
                    <Route path="/app/ctm/events" element={<CtmEventPage />} />
                    <Route path="/app/ctm/assets" element={<CtmPage />} />
                    <Route path="/app/locations" element={<LocationsPage />} />
                    <Route path="/app/locations/:locationId" element={<LocationPage />} />
                    <Route path="/app/location-service-start/:locationId" element={<LocationServiceStartPage />} />
                    <Route path="/app/location-service" element={<LocationServiceSearchPage />} />
                    <Route path="/app/location-service/:locationId" element={<LocationServicePage />} />
                    <Route path="/app/location-service/view/:locationId/:serviceDate" element={<LocationServiceViewPage />} />
                    <Route path="/app/location-service/:locationId/reports" element={<LocationReportTablePage />} />
                    <Route path="/app/location-service/:locationId/reports/generate" element={<LocationReportPage />} />
                </Route>

                <Route path="*" element={<div>Not Found</div>} />
            </Routes>
    );
}

export default AppRoutes;
